import { Pipe, PipeTransform } from '@angular/core';
import {PlayersAnswer} from "./players-answer";

@Pipe({
  name: 'playerFilter'
})
export class PlayerFilterPipe implements PipeTransform {

  transform(array: PlayersAnswer[], playerID: string): any {
    return array.filter(answer => answer.playerID == playerID);
  }

}



// WEBPACK FOOTER //
// ./src/app/player-filter.pipe.ts